import xyzToQuadkey from 'legacy/util/numbers/xyz-to-quadkey';

const constants = JSON.parse(document.getElementById('constants').innerHTML);

constants.isDeployed = location.hostname.match(/unearthlabs/);

constants.defaultSupportLink = 'support.procore.com/integrations/unearth';
constants.defaultSupportEmail = 'unearthsupport@procore.com';
constants.defaultSupportPhoneReference = '+12064871166';
constants.defaultSupportPhoneDisplay = '(206) 487-1166';
constants.defaultPrivacyPolicy = 'https://www.procore.com/legal/privacy';

constants.mapboxAccessToken = process.env.SDT_MAPBOX_ACCESS_TOKEN;

constants.baseTileURL = 'https://api.mapbox.com/styles/v1/n8mlr/ck3rhmolg2hsi1cow67u19pwi/tiles/512/{z}/{x}/{y}@2x?access_token=' + constants.mapboxAccessToken;

constants.basemaps = {
    satellite: {
        type: 'raster',
        tiles: ['https://api.mapbox.com/styles/v1/n8mlr/ck3rhmolg2hsi1cow67u19pwi/tiles/512/{z}/{x}/{y}@2x?access_token=' + constants.mapboxAccessToken],
        maxzoom: 21, // available up to zoom level 21 per https://docs.mapbox.com/help/glossary/mapbox-satellite/
        tileSize: 512
    },
    light: {
        type: 'raster',
        tiles: ['https://api.mapbox.com/styles/v1/n8mlr/cjsmfs9bz17lg1fsea9kniryl/tiles/512/{z}/{x}/{y}@2x?access_token=' + constants.mapboxAccessToken],
        maxzoom: 20,
        tileSize: 512
    },
    dark: {
        type: 'raster',
        tiles: ['https://api.mapbox.com/styles/v1/n8mlr/cjuk4q9ag1lba1fo5qeanaoql/tiles/512/{z}/{x}/{y}@2x?access_token=' + constants.mapboxAccessToken],
        maxzoom: 20,
        tileSize: 512
    },
    topo: {
        type: 'raster',
        tiles: ['https://api.mapbox.com/styles/v1/n8mlr/ckhky1l03028m19ptwj16wvq2/tiles/512/{z}/{x}/{y}@2x?access_token=' + constants.mapboxAccessToken],
        maxzoom: 20,
        tileSize: 512
    }
};

constants.apiVersion = '3.9';

constants.googleAPIKey = process.env.SDT_GOOGLE_API_KEY;


constants.unearthAccountId = 'iLZWUjsHJCNY6Pj-MKUY';

constants.baseTileOptions = {
    updateWhenZooming: false,
    maxNativeZoom: 24,
    maxZoom: 24,
    quadkey: xyzToQuadkey
};

constants.projectUserRoles = {
    suspended: {'key': 'suspended', ranking: 1, display: 'Suspended', writable: false},
    guest: {'key': 'guest', ranking: 2, display: 'Guest User', writable: false},
    general: {'key': 'general', ranking: 3, display: 'General User', writable: true},
    manager: {'key': 'manager', ranking: 4, display: 'Manager', writable: true},
    admin: {'key': 'admin', ranking: 5, display: 'Administrator', writable: true},
    owner: {'key': 'owner', ranking: 6, display: 'Owner', writable: true},
    superadmin: {key: 'superadmin', ranking: 7, display: 'Administrator', writable: false},
    viewer: {'key': 'viewer', ranking: 8, display: 'View Only', writable: true},
    limited: {'key': 'limited', ranking: 9, display: 'Limited edit access', writable: true}
};

constants.accountUserRoles = {
    superadmin: {key: 'superadmin', ranking: 8, display: 'Super Admin'},
    hidden: {key: 'hidden', ranking: 8, display: '-'},
    owner: {key: 'owner', ranking: 7, display: 'Owner'},
    admin: {key: 'admin', ranking: 6, display: 'Administrator'},
    manager: {key: 'manager', ranking: 5, display: 'Manager'},
    general: {key: 'general', ranking: 4, display: 'General User'},
    limited: {key: 'limited', ranking: 3, display: 'Limited User'},
    viewer: {key: 'viewer', ranking: 1, display: 'Viewer'},
    guest: {key: 'guest', ranking: 2, display: 'Guest User'}
};

constants.visibleRoles = [
    constants.accountUserRoles.owner.key,
    constants.accountUserRoles.admin.key,
    constants.accountUserRoles.manager.key,
    constants.accountUserRoles.general.key,
    constants.accountUserRoles.limited.key,
    constants.accountUserRoles.viewer.key
];

constants.permissionsRanks = {
    guest: 5,
    viewer: 10,
    limited: 15,
    general: 20,
    manager: 21,
    admin: 25,
    owner: 30,
    superadmin: 30,
    hidden: 30,
    WRITABLE_MIN: 22, // Does not account for limited user overrides
    ACCESS_WRITABLE_MIN: 21
};

constants.controlTypeIdToName = {
    'kHP5E7ytbCXDobUEpGUJ': 'area',
    'KWvNr3goaEC8ZTq6Pcvx': 'asset',
    'JClHKXspGsXCulXTAyiI': 'links',
    '98e1iwaVDBAvaOOX8R9B': 'color',
    '7xgQOT7XONk9QoD_ETaj': 'comments',
    'BLIOUucM-vfNsdWoy1HL': 'coordinates',
    's2ZgKG5YJ-h0K7kS49YN': 'date',
    '9bqDYEh-w-ZnQIjrtgx-': 'dateTime',
    'ltEqAmuRhCLTpW-n0n4b': 'dropdown',
    'RpThORwku_8GADvB7qKE': 'embed',
    'InwvONjdUiDHp9MCn8Nu': 'file',
    'pa2idyDpPoN_oDLcD91k': 'length',
    'QFRFEjSlK9HCERyHgVLO': 'multiselect',
    'XHrOauni2ZhI0FB1GzL8': 'multitext',
    'cHOO50gwqyqTIiy24lxX': 'name',
    'aITN7NyIRXyGHXKvwMAv': 'number',
    '50joA2aJxXFI4gR8mvx7': 'paragraph',
    '8Y0hi3g6q6IZT9focY9B': 'plan',
    '1UOw3bdiOONotKjYrSj_': 'project',
    'upr8Czy0FSyzOhO-bN4R': 'radio',
    'Nvhz7WVx2nYMO7Uzm7Dw': 'request',
    'hW0itVu6pbBIXF16G4SA': 'survey',
    '0K3uA1hBYt5PWb4-pGqb': 'text',
    'OR2gCMYvD9vQTu1nFBM1': 'toggle',
    '_0hPpJEtT0HyDxpX_6WB': 'URL',
    'EbAuM-i0vYuBEtSGVKcR': 'user',
    'owM1UO03S9ju7B_DntXK': 'volume',
    'ewmvVR6NZFCDcYY4x1YT': 'place',
    'g33Bu7ePDnd4nGK05gei': 'imodel'
};

constants.controlTypeNameToId = {
    'area': 'kHP5E7ytbCXDobUEpGUJ',
    'asset': 'KWvNr3goaEC8ZTq6Pcvx',
    'links': 'JClHKXspGsXCulXTAyiI',
    'color': '98e1iwaVDBAvaOOX8R9B',
    'comments': '7xgQOT7XONk9QoD_ETaj',
    'coordinates': 'BLIOUucM-vfNsdWoy1HL',
    'date': 's2ZgKG5YJ-h0K7kS49YN',
    'dateTime': '9bqDYEh-w-ZnQIjrtgx-',
    'dropdown': 'ltEqAmuRhCLTpW-n0n4b',
    'embed': 'RpThORwku_8GADvB7qKE',
    'file': 'InwvONjdUiDHp9MCn8Nu',
    'length': 'pa2idyDpPoN_oDLcD91k',
    'multiselect': 'QFRFEjSlK9HCERyHgVLO',
    'multitext': 'XHrOauni2ZhI0FB1GzL8',
    'name': 'cHOO50gwqyqTIiy24lxX',
    'number': 'aITN7NyIRXyGHXKvwMAv',
    'paragraph': '50joA2aJxXFI4gR8mvx7',
    'plan': '8Y0hi3g6q6IZT9focY9B',
    'project': '1UOw3bdiOONotKjYrSj_',
    'radio': 'upr8Czy0FSyzOhO-bN4R',
    'request': 'Nvhz7WVx2nYMO7Uzm7Dw',
    'survey': 'hW0itVu6pbBIXF16G4SA',
    'text': '0K3uA1hBYt5PWb4-pGqb',
    'toggle': 'OR2gCMYvD9vQTu1nFBM1',
    'URL': '_0hPpJEtT0HyDxpX_6WB',
    'user': 'EbAuM-i0vYuBEtSGVKcR',
    'volume': 'owM1UO03S9ju7B_DntXK',
    'place': 'ewmvVR6NZFCDcYY4x1YT',
    'imodel': 'g33Bu7ePDnd4nGK05gei'
};

constants.colors = {
    nameToHex: {
        green: '#07b050',
        blue: '#02b0f0',
        purple: '#944095',
        pink: '#e84495',
        red: '#d0021b',
        yellow: '#fff036',
        orange: '#eb7826',
        black: '#303840',
        gray: '#b7bec5',
        white: '#ffffff',
        teal: '#70BFBF'
    },
    hexToName: {
        '#07b050': 'green',
        '#02b0f0': 'blue',
        '#944095': 'purple',
        '#e84495': 'pink',
        '#d0021b': 'red',
        '#fff036': 'yellow',
        '#eb7826': 'orange',
        '#303840': 'black',
        '#b7bec5': 'gray',
        '#ffffff': 'white',
        '#70BFBF': 'teal'
    }
};

constants.baseToolboxes = {
    'AEC': {
        name: 'AEC',
        toolboxId: 'YMxl4hgY4cg1HN3VFuMz',
        attributes: {
            icon: {
                mediaId: 'Iqd46Ojx1scFcttk_IaL'
            }
        }
    },
    'Gas': {
        name: 'Gas',
        toolboxId: '2p88gH1nW8cN4Wlb8KYX',
        attributes: {
            icon: {
                mediaId: 'xEVi-o2qFrajw02WbEBr'
            }
        }
    },
    'Drone Services': {
        name: 'Drone Services',
        toolboxId: 'SU1OORTfgTxTPOecpN-f',
        attributes: {
            icon: {
                mediaId: 'EXFzkGPSb2EyQardkaE3'
            }
        }
    },
    'Sewer/Storm': {
        name: 'Sewer/Storm',
        toolboxId: 'yH5Wsry9VvqFimf8UBjt',
        attributes: {
            icon: {
                mediaId: '6le6S83bDWsAMr3hxBqr'
            }
        }
    }
};

constants.uploadOpts = {
    plan: {
        accept: ['image/bmp', 'image/gif', 'image/jpeg', 'image/pjpeg', 'image/png', 'image/tiff', 'image/x-tiff', 'application/vnd.google-earth.kml+xml', 'application/vnd.google-earth.kmz', '.kml', '.kmz', 'application/pdf', '.zip'],
        maxFiles: 1,
        minFiles: 1
    },
    survey: {
        accept: ['image/tiff', 'image/x-tiff', '.zip'],
        maxFiles: 1000,
        minFiles: 1
    }
};

constants.oneUpOrigin = constants.isDeployed ? document.location.origin : 'http://localhost:8003';

constants.dataCenterOrigin = constants.isDeployed ? document.location.origin : 'http://localhost:8085';

constants.staticMediaURL = 'https://static.unearthlabs.com/';

if (constants.awsProfile === 'production') {
    constants.customExportUrl = 'https://customreporter.unearthlabs.com';
    constants.mediaURL = 'https://media.unearthlabs.com/';
} else if (constants.awsProfile === 'staging') {
    constants.customExportUrl = 'https://customreporter-staging.unearthlabs.com';
    constants.mediaURL = 'https://media-staging.unearthlabs.com/';
} else {
    constants.customExportUrl = 'https://customreporter-dev.unearthlabs.com';
    constants.mediaURL = 'https://media-dev.unearthlabs.com/';
}

constants.customExportUrl += '/report';

constants.trimbleDataKey = '_locations';

constants.appURLs = {
    iOS: 'https://apps.apple.com/us/app/unearth-app/id1217649493',
    Android: 'https://play.google.com/store/apps/details?id=com.unearth.app'
};

constants.bentleyClientId = 'spa-162TnHLasmF8pKlAvWAj5kEIK';

constants.iModelViewerPath = constants.isDeployed ? `${document.location.origin}/bentley-viewer/` : 'http://localhost:3000/bentley-viewer/';

export default constants;
